"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header($view) {
        var _this = _super.call(this, $view) || this;
        _this.initListener();
        return _this;
    }
    Header.prototype.initListener = function () {
        this.initSearch();
        this.initScroll();
        this.initNavHover();
        this.initSubNavHover();
    };
    Header.prototype.initSearch = function () {
        this.$view.find('.search').on('click', function () {
            $('input[name="term"]').focus();
        });
    };
    Header.prototype.initScroll = function () {
        window.addEventListener('scroll', function () {
            var $headerBlock = document.getElementById('header');
            if ($headerBlock !== null) {
                if (window.scrollY > 50) {
                    $headerBlock.classList.add('is-sticky');
                }
                else {
                    $headerBlock.classList.remove('is-sticky');
                }
                if (window.scrollY > 30) {
                    $headerBlock.classList.add('hide-header');
                }
                else {
                    $headerBlock.classList.remove('hide-header');
                }
            }
            var $subheaderBlock = document.getElementById('product-comparator-subheader');
            if ($subheaderBlock !== null) {
                if (window.scrollY > 30) {
                    $subheaderBlock.classList.add('is-sticky');
                }
                else {
                    $subheaderBlock.classList.remove('is-sticky');
                }
            }
            if (window.scrollY >= 238) {
                $("body").addClass("fixed-header");
            }
            else {
                $("body").removeClass("fixed-header");
            }
        });
    };
    Header.prototype.initNavHover = function () {
        this.$view.find('.dropdown-menu').hover(function () { $('#NavOverlay').addClass('show'); }, function () { $('#NavOverlay').removeClass('show'); });
    };
    Header.prototype.initSubNavHover = function () {
        $('.container-nav-category .nav-item')
            .on('mouseover', function (e) {
            var cat = $(e.target).data('cat');
            var image = $("#".concat(cat));
            if (image.length) {
                $('.cat-image').addClass('d-none');
                image.removeClass('d-none');
            }
            else {
                Header.initImage();
            }
        })
            .on('mouseleave', function (e) {
            Header.initImage();
        });
    };
    Header.initImage = function () {
        $('.cat-image').addClass('d-none');
        $('.main-image').removeClass('d-none');
    };
    return Header;
}(BaseComponent_1.default));
exports.default = Header;
